// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__22QDo","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Tpir","obliqueLine":"membershipbadge_obliqueLine__2s6SB"};